module.exports = __webpack_public_path__ + "static/media/Jenkin_logo.8a26c0e5.png";